import { SocialNetworkMessage } from "../interfaces";

export function getSocialNetworkMessages(snFiltered: string[]): SocialNetworkMessage[] {
  return snFiltered.map((key: string) => {
    const sn = {
      code: key,
    };
    return sn;
  });
}
